<template>
    <div class="contactDiv" id='contact'>
        <h2>Contact</h2>
          <div class="contactSection">
            <div class="contactContainer">
              <div class="contact">
                <picture class="contactImg">
                    <source :srcset="require('@/assets/logos/transport-routier-logistique.webp')" type='image/webp' />
                    <img :src="require('@/assets/logos/transport-routier-logistique.png')" alt="Logo GMA symbolisant le transport en" loading="lazy" />
                </picture>
            </div>
              <div class="contactForm">
                  <form novalidate @submit.prevent="validateForm">
                      <div class="inputs">
                          <div class="input-container">
                              <input class="halfInput" v-model="form.firstname" type="text" required autocomplete="off" id="firstname">
                              <label for="firstname" :title="placeholderFirstname + '*'" ></label>
                              <span class="error_input" v-if="errors.firstname">{{ $t('form.error.firstname') }}</span>
                          </div>
                          <div class="input-container">
                              <input class="halfInput" v-model="form.lastname" type="text" required autocomplete="off" id="lastname">
                              <label for="lastname" :title="placeholderLastname + '*'" ></label>
                              <span class="error_input" v-if="errors.lastname">{{ $t('form.error.lastname') }}</span>
                          </div>
                      </div>
                      <div class="input-container">
                          <input class="allInput" v-model="form.email" type="email" required autocomplete="off" id="email">
                          <label for="email" :title="placeholderMail + '*'" ></label>
                          <span class="error_input" v-if="errors.email">{{ $t('form.error.email') }}</span>
                      </div>
                      <div class="input-container">
                          <input class="allInput" v-model="form.phone" type="phone" required autocomplete="off" id="phone">
                          <label for="phone" :title="placeholderPhone + '*'" ></label>
                          <span class="error_input" v-if="errors.phone">{{ $t('form.error.phone') }}</span>
                      </div>
                      <div class="inputs">
                          <div class="input-container">
                              <input class="halfInput" v-model="form.company" type="text" required autocomplete="off" id="company">
                              <label for="company" :title="placeholderCompany + '*'" ></label>
                              <span class="error_input" v-if="errors.company">{{ $t('form.error.company') }}</span>
                          </div>
                          <div class="input-container">
                              <input class="halfInput" v-model="form.url" type="text" required autocomplete="off" id="url">
                              <label for="url" :title="placeholderUrl" ></label>
                          </div>
                      </div>
                      <div class="input-container">
                          <input class="allInput" v-model="form.type" type="type" required autocomplete="off" id="type">
                          <label for="type" :title="placeholderType + '*'" ></label>
                          <span class="error_input" v-if="errors.type">{{ $t('form.error.type') }}</span>
                      </div>
                      <div class="input-container">
                          <input class="allInput" v-model="form.orders" type="orders" required autocomplete="off" id="orders">
                          <label for="orders" :title="placeholderOrders + '*'" ></label>
                          <span class="error_input" v-if="errors.orders">{{ $t('form.error.orders') }}</span>
                      </div>
                      <button type="submit"> {{ $t('form.button') }}</button>
                      <p class="success" v-if="successMessage"> {{ successMessage }} </p>
                      <p class="error" v-if="errorMessage">{{errorMessage}}</p>
                  </form>
              </div>
          </div>
        </div>
    </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import emailjs, { init } from '@emailjs/browser';

const { t } = useI18n();
const serviceID = process.env.VUE_APP_SERVICEID;
const templateID = process.env.VUE_APP_TEMPLATEID;
const publicKey = process.env.VUE_APP_PUBLICKEY;

init(publicKey);

const placeholderFirstname = computed(() => t('form.firstname'));
const placeholderLastname = computed(() => t('form.lastname'));
const placeholderMail = computed(() => t('form.email'));
const placeholderPhone= computed(() => t('form.phone'));
const placeholderCompany= computed(() => t('form.company'));
const placeholderUrl= computed(() => t('form.url'));
const placeholderType= computed(() => t('form.type'));
const placeholderOrders= computed(() => t('form.orders'));


const form = ref({ firstname: '', lastname: '', email: '', phone: '', company: '', url: '', type: '', orders: ''})
const successMessage = ref('');
const errorMessage = ref('');
const loading = ref(false);
const errors = ref({});

const validateForm = async() => {
  errors.value = {};

  if(!form.value.firstname) {
    errors.value.firstname = true;
  }
  if(!form.value.lastname) {
    errors.value.lastname = true;
  }
  if(!form.value.email) {
    errors.value.email = true;
  }
  if(!form.value.phone) {
    errors.value.phone = true;
  }
  if(!form.value.company) {
    errors.value.company = true;
  }
  if(!form.value.type) {
    errors.value.type = true;
  }
  if(!form.value.orders) {
    errors.value.orders = true;
  }
  if(Object.keys(errors.value).length > 0) {
    return
  }
  await sendMessage();
}

const sendMessage = async() => {
    loading.value = true;
    successMessage.value = '';
    errorMessage.value = '';

    const templateParams = {
        firstname: form.value.firstname,
        lastname: form.value.lastname,
        email: form.value.email,
        phone: form.value.phone,
        company: form.value.company,
        url: form.value.url,
        type: form.value.type,
        orders: form.value.orders
    }
    try {
        const response = await emailjs.send(
            serviceID, templateID, templateParams
        )
        if(response.status === 200) {
            successMessage.value = t('form.successMessage');
            form.value = { firstname: '', lastname: '', email: '', phone: '', company: '', url: '', type: '', orders: ''};
        } else {
            errorMessage.value = t('form.errorMessage');
            console.log('Response id not ok', response);
        }
    } catch (error) {
        console.error('error sending form message', error);
    } finally {
        loading.value = false;
    }

}
</script>

<style scoped>

h2 {
    text-align: left;
    color: #e91e63;
    font-size: 45px;
    text-align: center;
}
.contactSection {
  padding: 10px 0;
  background-color: #e91e63;
}
.contactContainer {
  display: flex;
  align-items: center;
}
 .contact, .contactForm {
  flex: 1;
 }
.contactImg {
  display: flex;
  width: 250px;
  height: auto;
  margin: auto;
}
 
.contactForm {
  width: 50%;
  padding: 0 50px;
}
 
.contactImg > img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
 
form {
  display: flex;
  flex-direction: column;
  max-width: 500px;
  margin: 0 auto;
}
 
.inputs {
  display: flex;
  gap: 20px;
}
 
.input-container {
  position: relative;
  width: 100%;
}
 
input {
  width: 100%;
  border: 2px solid #e91e63;
  border-radius: 5px;
  padding: 15px;
  font-size: 16px;
  transition: all 0.3s ease;
}
 
.input-container input:focus + label,
.input-container input:not(:placeholder-shown) + label {
  top: 0;
  font-size: 12px;
  color: #e91e63;
  background-color: white;
  transform: translateY(-50%);
}
 
button {
  color: #e91e63;
  border: none;
  border-radius: 5px;
  padding: 15px 30px;
  font-size: 18px;
  cursor: pointer;
  background: #ffffff;
  transition: background-color 0.3s ease, color 0.3s ease, border 0.3s ease;
}
 
button:hover {
  background-color: #e91e63;
  border: solid 1px #ffffff;
  color: #ffffff;
}
 
.success {
  color: #4CAF50;
  font-weight: bold;
}
 
.error {
  color: #f44336;
  font-weight: bold;
}
label-before, .input-container input:valid + label::before, .input-container input:focus + label::before {
    /* line-height: 20px; */
	font-size: 12px;
	top: -10px;
	/* background: #fff; */
	padding: 0 6px;
	left: 9px;
}
.input-container {
	position: relative;
	margin-bottom: 15px;
}
.input-container label::before {
	content: attr(title);
	position: absolute;
	top: 0;
	left: 15px;
	line-height: 40px;
	font-size: 14px;
	color: #777;
	transition: 300ms all;
  cursor: text;
}
.input-container input {
	/* width: 100%; */
	line-height: 40px;
	padding: 0 15px;
	box-sizing: border-box;
	font-size: 14px;
	color: #222;
	border: 1px solid #ccc;
	border-radius: 3px;
    border: solid 1px #e91e63;
}
.input-container input:focus {
	outline: 0;
	border-color: #e91e63;
}
.input-container input:valid + label::before {
	content: attr(data-title);
}
.input-container input:focus + label::before {
	color: #e91e63;
}
.error_input {
    font-size: 11px;
    float: left;
    color: #ffffff;
    padding: 2px;
}
@media screen and (min-width: 2000px ) {
  .contactContainer {
    max-width: 1440px;
    margin: auto;
  }
}

@media screen and (max-width: 750px ) {
    .contactContainer {
        flex-direction: column;
        padding: 20px;
    }
    .contactForm, .contactImg {
        width: 100%;
        padding: 0;
    }
    .contactImg > img {
      max-width: 55%;
      margin: auto;
    }
    .inputs {
        flex-direction: column;
        gap: 0;
    }
    form {
        margin: 40px auto;
    }
    h2 {
      padding-top: 0;
      margin-top: 0;
    }
}
</style>